import { ChangeDetectorRef, Component, EventEmitter, Output, Renderer2 } from '@angular/core';
import { getDownloadURL, UploadTask } from '@angular/fire/storage';
import { path_file } from '@app/config/path-file.enum';
import { StorageService } from '@app/services/storage.service';
import { DOC_ORIENTATION, NgxImageCompressService } from 'ngx-image-compress';

@Component({
  selector: 'app-input-file-rectangle',
  templateUrl: './input-file-rectangle.component.html',
  styleUrls: ['./input-file-rectangle.component.css']
})
export class InputFileRectangleComponent {

  public placeHolder: string = "";
  public title: string = "";
  public textFooter: string = "";
  public fileName: string = "";
  public inProgress: boolean = false;
  public progressPercentaje: number = 0;
  private pathFile: string = ""
  public urlImage: string = "";
  public fileType: string = "";
  public isImage: boolean = false;
  public style: string = '';

  public idInput: string = '';


  @Output() eventFileChange = new EventEmitter<any>();

  constructor(
    private renderer: Renderer2,
    private storageService: StorageService,
    private imageCompress: NgxImageCompressService,
    private cd: ChangeDetectorRef
  ) {

  }


  setInputType(inputType: string) {

    this.idInput = 'id'.concat(inputType);

    switch (inputType) {

      case 'inputDNIRecord':
        this.fileType = ".jpg, jpeg, .png";
        this.isImage = true;
        this.pathFile = path_file.EmployeeDNIRecord;
        this.placeHolder = "Haz clic y selecciona";
        this.style = "rectangle";
        this.textFooter = "(Ambos lados)";
        this.title = "Archivos de la cédula de identidad chilena";
        break;

      case 'inputVisaRecord':
        this.fileType = ".jpg, jpeg, .png";
        this.isImage = true;
        this.pathFile = path_file.EmployeeVisaRecord;
        this.placeHolder = "Haz clic y selecciona";
        this.style = "rectangle";
        this.textFooter = "";
        this.title = "Archivo PDF de la foto de tu visa";
        break;

      case 'inputEmployeeResume':
        this.fileType = ".pdf";
        this.isImage = false;
        this.pathFile = path_file.EmployeeResume;
        this.placeHolder = "Sube tu CV (*)";
        this.style = "link";
        this.textFooter = "";
        this.title = "";
        break;

      case 'inputEmployeePhoto':
        this.fileType = ".jpg, jpeg, .png";
        this.isImage = true;
        this.pathFile = path_file.UserPhoto;
        this.placeHolder = "Subir foto o avatar";
        this.style = "link";
        this.textFooter = "(opcional)";
        this.title = "";
        break;

      case 'inputTrainingInstituteLogo':
        this.fileType = ".jpg, jpeg, .png";
        this.isImage = true;
        this.pathFile = path_file.TrainingInstitute;
        this.placeHolder = "Haga clic para subir el logotipo";
        this.style = "rectangle";
        this.textFooter = "";
        this.title = "";
        break;

        case 'inputEmployeeEducation':
        this.fileType = ".pdf";
        this.isImage = false;
        this.pathFile = path_file.EmployeeEducation;
        this.placeHolder = "Haz clic y selecciona";
        this.style = "rectangle";
        this.textFooter = "";
        this.title = "Archivo PDF del certificado";
        break;

      case 'inputEmployeeLanguage':
        this.fileType = ".pdf";
        this.isImage = false;
        this.pathFile = path_file.EmployeeLanguage;
        this.placeHolder = "Haz clic y selecciona";
        this.style = "rectangle";
        this.textFooter = "";
        this.title = "Archivo PDF del certificado";
        break;

      case 'inputEmployeeTraining':
        this.fileType = ".pdf";
        this.isImage = false;
        this.pathFile = path_file.EmployeeTraining;
        this.placeHolder = "Haz clic y selecciona";
        this.style = "rectangle";
        this.textFooter = "";
        this.title = "Archivo PDF del certificado";
        break;

      case 'inputEmployeeSalary':
        this.fileType = ".jpg, jpeg, .png, .pdf";
        this.isImage = false;
        this.pathFile = path_file.SalarySettlement;
        this.placeHolder = "Haz clic y selecciona";
        this.style = "rectangle";
        this.textFooter = "Archivos permitidos: pdf, jpg, jpeg, o png.";
        this.title = "Archivo de la liquidación de sueldo o contrato de trabajo";
        break;

      case 'inputEmployeeSalaryException':
        this.fileType = ".jpg, jpeg, .png, .pdf";
        this.isImage = false;
        this.pathFile = path_file.SalaryException;
        this.placeHolder = "Haz clic y selecciona";
        this.style = "rectangle";
        this.textFooter = "Archivos permitidos: pdf, jpg, jpeg, o png.";
        this.title = "(Certificado de alumno, liquidación de sueldo en trabajo en otro rubro, etc.)";
        break;

    }
  }

  onSelectFile(event) {

    if (event.target.files && event.target.files[0]) {

      this.inProgress = true;
      this.progressPercentaje = 0;

      if (this.isImage) {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);

        reader.onload = (eventReader) => {

          var selectedFile: any = eventReader.target.result;

          this.imageCompress.compressFile(selectedFile, DOC_ORIENTATION.Up).then(
            result => {

              this.calculateProgressTask(this.storageService.uploadPhoto(result, Date.now().toString().concat('-', event.target.files[0].name), this.pathFile), event.target.files[0].name)

            }
          )
        }

      }
      else {
        this.calculateProgressTask(this.storageService.uploadFile(event.target.files[0], Date.now().toString().concat('-', event.target.files[0].name), this.pathFile), event.target.files[0].name)
      }
    }
  }

  calculateProgressTask(uploadTask: UploadTask, fileName: string) {
    uploadTask.on('state_changed',
      (snapshot) => {
        this.progressPercentaje = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        this.cd.detectChanges();
      },
      () => {

        this.inProgress = false;
        this.removeFile();
      },
      () => {



        if (this.isImage === true) {

          getDownloadURL(uploadTask.snapshot.ref).then(url => {

            this.inProgress = false;
            this.fileName = fileName;
            this.urlImage = url;

            this.eventFileChange.next({
              state: 'success',
              fileName: this.fileName,
              reference: url
            });

            this.cd.detectChanges();

          });

        } else {

          this.inProgress = false;
          this.fileName = fileName;

          this.eventFileChange.next({
            state: 'success',
            fileName: this.fileName,
            reference: uploadTask.snapshot.ref.name
          });

          this.cd.detectChanges();

        }
      })
  }

  removeFile() {
    this.fileName = '';
    this.urlImage = '';

    this.eventFileChange.next({
      state: 'delete',
      fileName: '',
      reference: ''
    })
    this.cd.detectChanges();

  }

  setPhotoValue(url: string) {

    if (!url) { return }

    this.urlImage = url;

    try {
      this.setFileValue(url.split('/').pop().split('#')[0].split('?')[0]);
    }
    catch
    {
      this.setFileValue("Eliminar");
    }
    
  }

  setFileValue(fileName: string) {

    if (!fileName) { return; }

    var ix = fileName.indexOf("-");

    var file = fileName;

    if (ix >= 0) {
      file = fileName.slice(ix + 1, fileName.length);
    }

    this.fileName = file === "" ? 'Eliminar' : file;
    this.cd.detectChanges();

  }

  reset() {
    this.inProgress = false;
    this.progressPercentaje = 0;
    this.urlImage = '';
    this.fileName = '';
    this.cd.detectChanges();

  }

  openDialog()
  {
    const element = document.getElementById(this.idInput);

    if (element) {
      this.renderer.selectRootElement(element).click();
    }
  }
}
